import { createStore, applyMiddleware, compose } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

import reducer from './modules/reducer';

export default function configureStore() {
  const middleware = [thunk];

  if (
    process.env.REACT_APP_ENABLE_REDUX_LOGGER === 'true' &&
    process.env.NODE_ENV !== 'production' &&
    process.env.NODE_ENV !== 'test'
  ) {
    middleware.push(logger);
  }

  return createStore(
    reducer,
    compose(
      applyMiddleware(...middleware),
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()
        : compose
    )
  );
}
